<template>
  <div class="u-flex u-align-center u-margin-left-toolbar">
    <span>{{ $t('tables.limitSelectorLabel') }}</span>
    <gl-select
      id="admin.limitSelector"
      v-skeletor:onChange="setNumPage"
      :options="JSON.stringify(dataList)"
      :value="JSON.stringify(selectedOption)"
      :separator="true"
      :auto-width="true"
      class="u-margin-left-toolbar"
    >
    </gl-select>
  </div>
</template>

<script>
import TableDatasource from './TableDatasource';

export default {
  name: 'TableLimitSelector',
  props: {
    dataSource: {
      type: Object,
      default: () => new TableDatasource()
    }
  },
  data() {
    return {
      dataList: [],
      selectedOption: ['10'],
      dirtyFields: false
    };
  },
  created() {
    this.setNumPage(null, ['10']);

    if (!this.dataSource.limitOptions.length) {
      return;
    }
    this.dataList = this.dataSource.limitOptions.map((option) => {
      return { key: String(option), value: String(option) };
    });
  },

  methods: {
    setNumPage(field, num, dirty) {
      this.selectedOption = num;
      this.dataSource.refresh({ limit: num, page: 1 });
      this.setDirtyField(dirty);
    },
    setDirtyField(dirty) {
      this.dirtyFields = dirty;
    }
  }
};
</script>
